import React from 'react';
import './sectionfour.css';


export default function SectionFour({heading, text, avatar}) {
    return (
        <div className="sectionFour__main">
            <div className="sectionFour">
                <div className="sectionFour__left">
                    <h1  data-aos='zoom-out-down' className="head__one">{heading}</h1>
                    <p data-aos='fade-down'  className="paragraph">{text}</p>
                    <button data-aos='zoom-in-down'  className="primary__button">Contact us</button> 
                </div>
                <div className="sectionFour__right">
                    <img data-aos='zoom-in-down'  src={avatar} alt=""/>
                </div>
        </div>
       </div>
    )
}
